import script from "./voidPosReport.vue?vue&type=script&setup=true&lang=js"
export * from "./voidPosReport.vue?vue&type=script&setup=true&lang=js"

import "./voidPosReport.vue?vue&type=style&index=0&id=68684c6a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68684c6a"]])

export default __exports__